<template>
  <v-btn icon :class="[color, variant + '--text', 'rounded-circle', $attrs.class]" v-bind="$attrs" v-on="$listeners">
    <v-icon v-if="icon">{{ icon }}</v-icon>
  </v-btn>
</template>

<script>
export default {
  props: {
    icon: { type: String, required: true },
    color: { type: String, default: 'secondary' },
    variant: { type: String, default: 'primary' },
  },
}
</script>

<style scoped>
.rounded-circle {
  border-radius: 50% !important;
}
</style>
